import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Discount } from '../../models/discount.model';
import { DiscountCode } from '../../models/discount-code.model';

@Component({
  selector: 'app-discounts-selector',
  templateUrl: './discounts-selector.component.html',
  styleUrls: ['./discounts-selector.component.scss']
})
export class DiscountsSelectorComponent implements OnInit {

    @Input() discounts            : Discount[];
    @Input() maxDiscount          : number;
    @Input() selectedDiscountCodes: DiscountCode[];
    @Input() selectedTotalDiscount: number;

    @Output() selectedDiscountCodesChange = new EventEmitter<DiscountCode[]>();
    @Output() selectedTotalDiscountChange = new EventEmitter<number>();

    public labels: any = {
        totalDiscountAlertLabel: 'Su descuento total es:',
    }

    public discountsWithoutCode        : Discount[];
    public selectedDiscountsWithoutCode: DiscountCode[];
    public discountsWithCode           : Discount[];
    public selectedDiscountsWithCode   : DiscountCode[];

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        this.selectedDiscountCodes        = this.selectedDiscountCodes ?? [];
        this.discountsWithoutCode         = this.discounts?.filter(d => !d.hasCodes) ;
        this.discountsWithCode            = this.discounts?.filter(d => d.hasCodes);

        this.selectedDiscountsWithoutCode = this.discountsWithoutCode
            .flatMap(dwc => dwc.discountCodes)
            .filter(dc => this.selectedDiscountCodes.map(sdc => sdc.code).includes(dc.code));

        this.selectedDiscountsWithCode= this.discountsWithCode
            .flatMap(dwc => dwc.discountCodes)
            .filter(dc => this.selectedDiscountCodes.map(sdc => sdc.code).includes(dc.code));

    }

    public onSelectedDiscountsChange() {

        let allDiscounts = this.selectedDiscountsWithoutCode.concat(this.selectedDiscountsWithCode);
        let totalDiscountSum = allDiscounts.reduce((acc, {percentage}) => acc + percentage, 0);
        this.selectedTotalDiscount = totalDiscountSum > this.maxDiscount ? this.maxDiscount : totalDiscountSum;

        this.updateData();

    }

    private updateData() {

        this.selectedDiscountCodes = [];
        this.selectedDiscountCodes = structuredClone(this.selectedDiscountsWithoutCode.concat(this.selectedDiscountsWithCode));

        this.selectedDiscountCodesChange.emit(this.selectedDiscountCodes);
        this.selectedTotalDiscountChange.emit(this.selectedTotalDiscount);

    }



}
